import React, { useMemo } from 'react';

import useUserData from 'hooks/useUserData';

import PersonAvatar from '../PersonAvatar';

interface UserAvatarProps {
  size: number;
  highlighted?: boolean;
}

export default function UserAvatar({ size, highlighted = true }: UserAvatarProps) {
  const userData = useUserData();

  const variantsBasedOnSize = useMemo<string>(() => {
    if (size <= 32) return userData.profile_image_variants?.xs;
    if (size <= 64) return userData.profile_image_variants?.sm;
    if (size <= 128) return userData.profile_image_variants?.md;
    if (size <= 256) return userData.profile_image_variants?.lg;
    if (size <= 512) return userData.profile_image_variants?.xl;
    return userData.profile_image_variants?.full;
  }, [size, userData.profile_image_variants]);

  return (
    <PersonAvatar
      size={size}
      name={userData.first_name}
      lastName={userData.last_name}
      avatar={variantsBasedOnSize}
      highlighted={highlighted}
      disablePropagation
    />
  );
}
